export class FormatUtils {

  static getEmailFormat(email: string) {
    return email?.replace(/\s/g, '').toLowerCase();
  }

}